function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import AsyncCreatable from 'react-select/async-creatable';
import { useFormContext, Controller } from 'react-hook-form';
import Async from 'react-select/async';
import { parseValidators } from '../util';
import CommonSelect from './CommonSelect';
import FormRow from './FormRow';
var asyncSelectTimeout = null;
var AsyncSelect = function AsyncSelect(_ref) {
  var description = _ref.description,
    label = _ref.label,
    messages = _ref.messages,
    name = _ref.name,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    validators = _ref.validators,
    required = _ref.required,
    allowsNewSelection = _ref.allowsNewSelection,
    asyncCallback = _ref.asyncCallback,
    isClearable = _ref.isClearable,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? {
      value: ''
    } : _ref$defaultValue,
    maxLength = _ref.maxLength,
    minLength = _ref.minLength,
    placeholder = _ref.placeholder,
    readOnly = _ref.readOnly,
    _ref$requestInterval = _ref.requestInterval,
    requestInterval = _ref$requestInterval === void 0 ? 600 : _ref$requestInterval,
    sort = _ref.sort,
    _ref$onChange = _ref.onChange,
    customOnChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _noOptionsMessage = _ref.noOptionsMessage;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var loadOptions = function loadOptions(input, callback) {
    if (input.length < minLength) {
      callback([]);
      return;
    }
    if (asyncSelectTimeout) {
      clearTimeout(asyncSelectTimeout);
    }
    asyncSelectTimeout = setTimeout(function () {
      asyncCallback(input).then(function (options) {
        callback(options);
      }).catch(function () {
        callback([]);
      });
    }, requestInterval);
  };
  var Selector = allowsNewSelection ? AsyncCreatable : Async;
  return /*#__PURE__*/React.createElement(FormRow, {
    messages: messages,
    description: description,
    label: label,
    name: name,
    required: typeof required !== 'undefined' ? required : !!validators,
    styles: styles
  }, /*#__PURE__*/React.createElement(Controller, {
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
        _onChange = _ref2$field.onChange,
        onBlur = _ref2$field.onBlur,
        value = _ref2$field.value,
        name = _ref2$field.name;
      return /*#__PURE__*/React.createElement(CommonSelect, {
        allowsNewSelection: allowsNewSelection,
        isClearable: isClearable,
        loadOptions: loadOptions,
        name: name,
        onBlur: onBlur,
        onChange: function onChange(args) {
          var processedArgs = _objectSpread(_objectSpread({}, args), {}, {
            // NOTE: We are using a classname injected by react-select to determine
            // if a new selection was created. This seems prone to errors if / when we
            // update react-select. However, this seems to be the least hacky of solutions
            newSelection: args.className && /option-placeholder/.test(args.className)
          });
          customOnChange(processedArgs);
          return _onChange(processedArgs);
        },
        placeholder: placeholder,
        readOnly: readOnly,
        noOptionsMessage: function noOptionsMessage() {
          return _noOptionsMessage || '';
        },
        sort: sort,
        value: value,
        wrapper: Selector,
        maxLength: maxLength
      });
    },
    defaultValue: defaultValue,
    name: name,
    control: control,
    rules: parseValidators({
      messages: messages,
      validators: validators
    })
  }));
};
export default AsyncSelect;